export const selectAllowedTabList = (state: any) =>
  state.sidebarPermissions.allowedTabList;

export const selectSidebarProperties = (state: any) =>
  state.sidebarPermissions.properties;

export const selectSidebarOrders = (state: any) =>
  state.sidebarPermissions.orders;

export const selectSidebarOrderDetails = (state: any) =>
  state.sidebarPermissions.orderDetails;

export const selectSidebarKeyContacts = (state: any) =>
  state.sidebarPermissions.keyContacts;